/* eslint no-console:0 */

const $ = (global.$ = global.jQuery = require("jquery"));
require("jquery-ujs");
import "slick-carousel";
require("../modules/legacy/lightbox");

import { Kefir as K } from "kefir";
import { queryOne, queryChild } from "@standard-library/q-prime";
import imagesLoaded from "imagesloaded";
import Cookie from "js-cookie";

import dom from "../modules/dom";
import flaneur from "../modules/f";
import GoogleMap from "../modules/googleMap";
import Video from "../modules/video";

global.GoogleMap = GoogleMap;

const o = dom(document);

const resize = K.fromEvents(window, "resize");
const scroll = K.fromEvents(window, "scroll");
const scrollY = scroll.map(() => window.scrollY).toProperty(() => 0);

const navigation = o(".main-navigation");
const flanerie = flaneur(
  {
    modifier: K.constant(d => Math.max(1000, d / 2)),
    offset: navigation.propertyBy(resize, "offsetHeight").map(o => -o)
  },
  scrollY
);

o.loaded.observe(() => {
  // mobile nav

  $("#hamburger").click(function() {
    // open hamburger icon, animate and change color
    $(this).toggleClass("open");

    // 2. show mobile header
    $(".mobile-navigation--open").toggleClass("mobile-open");

    return false;
  });

  // sliders w/Slick

  function updateCaption($slide, $caption) {
    const caption = $slide.eq(0).data("caption");

    $caption.toggleClass("is-hidden", !caption);
    $caption.find("p").text(caption);
  }

  $(".slider").each(function() {
    var $slider = $(this);

    $slider.slick({
      arrows: true,
      slidesToShow: 1,
      speed: 2000,
      nextArrow: '<div class="pagination pagination--next"></div>',
      prevArrow: '<div class="pagination pagination--prev"></div>'
    });

    $slider.find(".left").click(function() {
      $slider.slick("slickPrev");
    });

    $slider.find(".right").click(function() {
      $slider.slick("slickNext");
    });

    // change slider caption

    var $caption = $slider.siblings(".slider-caption");

    updateCaption($slider.find(".slide").eq(1), $caption);

    $slider.on("beforeChange", function(e, slick, current, next) {
      $caption.stop().fadeTo(150, 0, function() {
        updateCaption(slick.$slides.eq(next).find(".slide"), $caption);
      });
    });

    $slider.on("afterChange", function() {
      $caption.stop().fadeTo(150, 1);
    });
  });

  $(".unit__details").hide();
  $(".unit").on("click", function(e) {
    if (!$(e.target).is("a")) {
      const $unit = $(this);
      const $units = $(".unit");

      $unit.toggleClass("is-active");
      $unit.find(".unit__details").slideToggle();
    }
  });

  // Video player

  Video($(".video-player"));
});

// desktop nav link dropdowns

const navigationContainers = o.list(".main-navigation .nav-links");
const navigationLinks = o.list(".main-navigation li"); // top-level links only
const navigationDropdowns = o.list(".main-navigation .dropdown");
const activeDropdown = navigationLinks.hovered.map(
  e => (e ? queryChild(e, ".dropdown") : undefined)
);

K.combine([navigationContainers, activeDropdown]).observe(([cs, d]) => {
  const dropdownHeight = d ? d.offsetHeight : 0;
  cs.forEach(c => {
    c.style.paddingBottom = `${dropdownHeight}px`;
  });
});

navigationDropdowns.indicate("dd--visible", activeDropdown);

// fade out hero title text, change hero image to color

const hero = o.maybe(".hero");
const heroText = o.maybe(".hero-text");

const heroActivated = hero
  .filter(e => $(e).data("fade") !== "video")
  .delay(1500);

hero.className("color", heroActivated);
heroText.className("is-deactivated", heroActivated);

scroll.observe(function() {
  var pixelsFromTop = $(document).scrollTop();

  if (pixelsFromTop > 100) {
    $(".nav-top").fadeOut(800);
  } else {
    $(".nav-top").fadeIn(800, function() {
      // fixes an error where the nav would display block when the page is
      // scrolled and the window resized.
      $(this).css("display", "flex");
    });
  }
});
 
// parallax hero effect
o.loaded.observe(function() {
  var $win = $(window);

  $(".hero").each(function() {
    var scrollSpeed = 10;
    var $this = $(this);
    var $image = $this.find(".hero__image");

    $(window).scroll(function() {
      var bgScroll = -(($win.scrollTop() - $this.offset().top) / scrollSpeed);
      $image.css({ transform: `translateY(${bgScroll}px)` });
    });
  });
});

// sticky header

scroll.observe(function() {
  var pixelsFromTop = $(document).scrollTop();
  var height = window.innerHeight;

  $(".nav-top").toggleClass("nav-sticky is-shown", pixelsFromTop + 100 > height);
});

// fade in

K.merge([scroll, o.loaded]).observe(function() {
  var pageTop = $(document).scrollTop();
  var pageBottom = pageTop + $(window).height();
  var tags = $(".row, .slider");

  for (var i = 0; i < tags.length; i++) {
    var tag = tags[i];

    if ($(tag).offset().top < pageBottom) {
      $(tag).addClass("visible");
    } else {
      $(tag).removeClass("visible");
    }
  }
});

// Contact form

const brokerageField = o.maybe(".field--brokerage");
const brokerField = o.maybe("#registrant_broker_true");
const purchaserField = o.maybe("#registrant_broker_false");

const ajaxSuccess = K.fromEvents(
  $(document),
  "ajax:success",
  (event, data) => ({ event, data })
);

const formSubmit = ajaxSuccess.filter(
  ({ event }) => event.target.nodeName === "FORM"
);

const formSuccess = formSubmit.filter(({ data }) => data.status === "success");

const brokerSelected = K.merge([
  purchaserField.events("change").map(() => false),
  brokerField.events("change").map(() => true),
  brokerField.map(e => e.checked)
]);

brokerageField.className("is-hidden", brokerSelected.map(s => !s));

formSubmit.observe(({ event, data }) => {
  $(event.target).replaceWith(data.template);

  const $errors = $(".error");

  if ($errors.length) {
    $("html, body").animate({ scrollTop: $errors.offset().top - 100 }, 2000);
  }
});

formSuccess.observe(() => {
  if (typeof dataLayer !== "undefined") {
    dataLayer.push({
      event: "VirtualPageview",
      gaEventCategory: "Contact Form",
      gaEventAction: "Form Submit",
      gaEventLabel: "Thank You"
    });

    dataLayer.push({
      event: "VirtualPageview",
      virtualPageURL: "/thanks",
      virtualPageTitle: "Thank You Page"
    });
  }
});

// change neighborhood to beige

// $(document).on("scroll", function() {
//   var pixelsFromTop = $(document).scrollTop();

//   if (pixelsFromTop > 800) {
//     $(".content.neighborhood").addClass("beige");
//     $(".neighborhood-map").addClass("beige");
//   } else {
//     $(".content.neighborhood").removeClass("beige");
//     $(".neighborhood-map").removeClass("beige");
//   }
// });


// Legal text

// const legal = o(".legal");
// const legalClose = o.maybe(".legal__close");
// const legalToggle = o.maybe(".legal-toggle");

// const legalToggleClick = K.merge([
//   legalToggle.events("click"),
//   legalClose.events("click")
// ]);

// const legalShown = legalToggleClick.scan(p => !p, false);

// legalToggleClick.observe(e => e.preventDefault());

// legal.className("is-shown", legalShown);

// On-page links
const intralinks = o.list(".main-navigation [href*='#']");
const intralinksClick = intralinks.events("click");
const linkHash = intralinksClick.map(e => e.target.href.split("#")[1]);
const documentHash = o.loaded
  .map(() => window.location.hash)
  .filter(h => !!h)
  .map(h => h.substring(1));
const targetName = K.merge([linkHash, documentHash]);
const target = targetName
  .map(name => queryOne(`[data-name="${name}"]`))
  .filter(t => !!t);

flanerie.regard(target);

// Homepage blurb and logo

const heroLogo = o.maybe(".hero-logo");
const heroLogoHeight = heroLogo.propertyBy(resize, "offsetHeight");
const heroLogoHalfHeight = heroLogoHeight.map(h => h / 2);

const blurb = o.maybe(".blurb");
const blurbText = o.maybe(".blurb__text");
const blurbToggle = o.maybe(".blurb__toggle");

const blurbShown = blurbToggle.events("click").scan(() => true, false);

const blurbTextHeight = blurbText.propertyBy(resize, "offsetHeight");
const blurbCramped = K.combine(
  [blurbTextHeight, heroLogoHeight],
  (t, l) => t > (window.innerHeight - l) / 2 - 50
);
const heroLogoObscured = K.combine(
  [blurbShown, blurbCramped],
  (s, c) => s && c
);

heroLogo.className("is-obscured", heroLogoObscured);

blurb.className("has-room", blurbCramped);
blurbText.className("is-shown", blurbShown);
blurbToggle.className("is-hidden", blurbShown);
blurb.style({
  paddingTop: heroLogoHalfHeight.map(h => `${h}px`)
});

// Unit navigation

const units = o.list(".unit");
const diagramLocations = o.list(".diagram-img [id^='unit']");
const selectedLocations = units.hovered.map(
  u => (u ? JSON.parse(u.dataset.diagramLocations) : u)
);

diagramLocations.indicateUnits(selectedLocations);

// Diagram location

const diagram = o.maybe("[data-diagram]");
const diagramNavigation = o.maybe("[data-diagram-navigation]");

const diagramNavigationOffset = diagramNavigation
  .sampledBy(scrollY)
  .map(e => e.getBoundingClientRect().top - 100);

const diagramHeight = K.merge([diagram, diagram.sampledBy(resize)]).map(
  e => e.offsetHeight
);
const diagramNavigationHeight = K.merge([
  diagramNavigation,
  diagramNavigation.sampledBy(resize),
  diagramNavigation.sampledBy(K.interval(100))
]).map(e => e.offsetHeight);
const diagramRequestedOffset = diagramNavigationOffset.map(o =>
  Math.max(0, -o)
);
const diagramMarginTop = K.combine(
  [diagramNavigationHeight, diagramRequestedOffset, diagramHeight],
  (n, o, h) => Math.min(n - h, o)
);

diagram.style({
  marginTop: diagramMarginTop.map(p => `${p}px`)
});

// Overlay

// const overlay = o(".overlay");
// const overlayClose = o(".overlay__close");

// const domain = window.location.hostname
//   .split(".")
//   .slice(-2)
//   .join(".");
// const overlayPreviouslyDismissed = K.constant(
//   Cookie.get("overlay", { domain }) === "dismissed"
// );
// const dismissOverlay = overlayClose.events("click");
// const overlayShown = K.merge([
//   overlay
//     .delay(1000)
//     .map(() => true)
//     .filterBy(overlayPreviouslyDismissed.map(d => !d)),
//   dismissOverlay.map(() => false)
// ]).toProperty(() => false);

// overlay.className("is-shown", overlayShown);
// dismissOverlay.observe(() => {
//   Cookie.set("overlay", "dismissed", { domain });
// });

$(function() {
  // Make the footer sticky when scrolling up the page

  var lastScrollTop = 0;
  var $body = $('body');
  var $header = $('.main-navigation');
  var $footer = $('.footer');
  //var $footerClone = $footer.clone().addClass('footer--clone');
  var documentHeight = $(document).height();
  var windowHeight = $(window).height();
  var footerHeight = $footer.outerHeight();
  var isMobile = $(window).width() < 1000;

  //$footer.after($footerClone);

  $(window).on('resize', function() {
    documentHeight = $(document).height();
    windowHeight = $(window).height();
    footerHeight = $footer.outerHeight();
    isMobile = $(window).width() < 1000;
  });

  $(window).on('scroll', function() {
    // Don't do the sticky footer on mobile
    if ( isMobile ) return;

    var st = window.pageYOffset || document.documentElement.scrollTop;

    if ( st > lastScrollTop ) {
      // scrolling down
      $body.removeClass('is-scrolling-up');
    } else {
      // scrolling up

      if ( st + windowHeight < documentHeight - footerHeight - 100 ) {
        if ( $header.hasClass('is-shown') ) {
          $body.addClass('is-scrolling-up');
        } else {
          $body.removeClass('is-scrolling-up');
        }
      } else {
        $body.removeClass('is-scrolling-up');
      }
    }

    lastScrollTop = st <= 0 ? 0 : st;
  });
});

// External links
$(function() {
  var documentHost = document.location.href.split('/')[2];
  var internalLinkExceptions = ['mailto:', 'tel:', 'sms:', 'javascript:'];
  var subdomainPattern = RegExp('^(www|en|es|pt)\.');

  if ( documentHost ) {
    documentHost = documentHost.replace(subdomainPattern, '');
  }

  var isExternalLink = function($el) {
    var href = $el.attr('href');
    var link = $el.get(0).href;
    var linkHost = link.split('/')[2];

    if ( linkHost ) {
      linkHost = linkHost.replace(subdomainPattern, '');
    }

    var internalLinkMatches = $.map(internalLinkExceptions, function(d) {
      if ( href ) {
        return href.indexOf(d) != -1;
      } else {
        return true;
      }
    });

    return linkHost != documentHost && ( $.inArray(true, internalLinkMatches) === -1 );
  };

  $('a').each(function() {
    var $link = $(this);

    if ( isExternalLink($link) ) {
      $link.addClass('external-link')
           .on('click.externalLinks', function() {
             window.open(this.href);
             return false;
           });
    }
  });
});

// Lazy videos
// Video tag placeholders avoid an issue related to turbolinks and videos that
// continue to play during page navigation.
// https://github.com/turbolinks/turbolinks/issues/177

$(function() {
  var $placeholders = $('.lazy-video-placeholder');
  var turnOffEventListeners = function() {
    $(window).off('resize.lazyLoadVideo scroll.lazyLoadVideo');
  };

  if ( !$placeholders.length ) {
    return;
  } else {
    turnOffEventListeners();
  }

  $placeholders.each(function() {
    var $placeholder = $(this);
    var videoHTML = $placeholder.attr('data-video-tag-html');
    var $video = $(videoHTML);
    var video = $video.get(0);
    var srcFull = $video.attr('data-src');
    var srcMobile = $video.attr('data-src-mobile');
    var src;

    src = srcFull;

    // if ( App.breakpoint.isMobile() && srcMobile ) {
    //   src = srcMobile;
    // } else {
    //   src = srcFull;
    // }

    $video.addClass('lazy-video').attr('src', src);
    $placeholder.hide().after($video);
  });

  var $videos = $('.lazy-video');

  // var checkForVisibility = function() {
  //   $videos.each(function() {
  //     var $video = $(this);
  //     var video = $video.get(0);
  //     var player = video;
  //     var autoplay = $video.attr('autoplay');

  //     if ( !autoplay || autoplay == 'false' ) {
  //       $video.data('lazy-load-video-autoplay-disabled', true);
  //       return;
  //     }

  //     if ( App.inViewport(this) ) {
  //       var playPromise = player.play();

  //       if ( playPromise !== undefined ) {
  //         playPromise.then(function() {
  //           // Automatic playback started!
  //           // Show playing UI.
  //         }).catch(function(error) {
  //           // Auto-play was prevented
  //           // Show paused UI.

  //           console.log('Error playing video', error);
  //         });
  //       }
  //     } else {
  //       player.pause();
  //     }
  //   });
  // };

  // checkForVisibility();

  // $(window).on('resize.lazyLoadVideo', $.debounce( 500, function() {
  //   checkForVisibility();
  // }));

  // $(window).on('scroll.lazyLoadVideo', $.throttle( 500, function() {
  //   checkForVisibility();
  // }));

  var $disabledVideos = $placeholders.filter(function() {
    return $(this).data('lazy-load-video-autoplay-disabled') == true;
  });

  if ( $placeholders.length == $disabledVideos.length ) {
    turnOffEventListeners();
  }
});



jQuery(document).ready(function ($) {
  'use strict';

  // Legal click fancy ======================
  $('.legal-toggle').click(function (e) {
    $(".legal").addClass('is-shown');
  });

  $('.legal__close').click(function (e) {
    $(".legal").removeClass('is-shown');
  });
  // Legal click fancy ======================

  // blocks h2 ======================
  $('.neighborhood .wrapper--blocks p b').wrapInner( "<h2></h2>");
  // blocks h2 ======================

});


// WEBPACK FOOTER //
// ./app/javascript/packs/application.js